import { useState, useMemo } from "react";
import AppLayout from "../../../components/AppLayout/AppLayout";
import { useNavigate } from "react-router-dom";

const allTrips = [
  { sno: "01", date: "12 Jun 2025", km: "230",   leadId: "54563", start: "54563 km", end: "54780 km" },
  { sno: "02", date: "11 Jun 2025", km: "450",   leadId: "52163", start: "54563 km", end: "54780 km" },
  { sno: "03", date: "09 Jun 2025", km: "1,230", leadId: "54653", start: "54563 km", end: "54780 km" },
  { sno: "04", date: "12 Jun 2025", km: "430",   leadId: "54123", start: "54563 km", end: "54780 km" },
  { sno: "05", date: "08 Jun 2025", km: "310",   leadId: "53900", start: "54200 km", end: "54510 km" },
  { sno: "06", date: "07 Jun 2025", km: "780",   leadId: "53100", start: "53100 km", end: "53880 km" },
];

const PER_PAGE = 3;

const uniqueDates = [...new Set(allTrips.map((t) => t.date))];

export default function TripHistory({ onBack }) {
  const [dateFilter, setDateFilter] = useState("");
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  const filtered = useMemo(
    () => (dateFilter ? allTrips.filter((t) => t.date === dateFilter) : allTrips),
    [dateFilter]
  );

  const totalPages = Math.ceil(filtered.length / PER_PAGE);
  const visible = filtered.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  const handleDateChange = (e) => {
    setDateFilter(e.target.value);
    setPage(1);
  };

  return (
    <AppLayout>
       <div style={{ minHeight: "100vh", background: "#f7f7f7" }}>

      {/* Header */}
   
      {/* Breadcrumb */}
      <div style={{ background: "#fff", padding: "8px 14px", borderBottom: "0.5px solid #eee", display: "flex", gap: 6 }}>
        <span style={{ fontSize: 12, color: "#888" }}>Home</span>
        <span style={{ fontSize: 12, color: "#aaa" }}>›</span>
        <span style={{ fontSize: 12, color: "#888" }}>Trip History</span>
      </div>

      <div style={{ padding: 14 }}>

        {/* Section Header */}
        <div style={{ background: "#534AB7", borderRadius: 8, padding: "12px 14px", marginBottom: 14 }}>
          <span style={{ color: "#fff", fontSize: 14, fontWeight: 500 }}>Trip History</span>
        </div>

        {/* Filter + Pagination */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
          <select
            value={dateFilter}
            onChange={handleDateChange}
            style={{
              padding: "6px 10px", border: "1px solid #d0c8f0", borderRadius: 8,
              fontSize: 12, color: "#555", background: "#fff", outline: "none",
            }}
          >
            <option value="">DD-MM-YYYY</option>
            {uniqueDates.map((d) => <option key={d} value={d}>{d}</option>)}
          </select>

          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <PaginationBtn label="‹" onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1} />
            <span style={{
              width: 28, height: 28, background: "#534AB7", color: "#fff",
              borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13,
            }}>{page}</span>
            <PaginationBtn label="›" onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={page === totalPages} />
          </div>
        </div>

        {/* Trip Cards */}
        {visible.map((trip) => (
  <TripCard
    key={trip.sno}
    trip={trip}
    onClick={() => navigate("/trip-detail", { state: { trip } })}
  />
))}

        {visible.length === 0 && (
          <p style={{ textAlign: "center", color: "#aaa", fontSize: 13, marginTop: 40 }}>
            No records found for this date.
          </p>
        )}
      </div>
    </div>
    </AppLayout>
   
  );
}

function PaginationBtn({ label, onClick, disabled }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        width: 28, height: 28, border: "1px solid #d0c8f0", borderRadius: 6,
        background: "#fff", cursor: disabled ? "not-allowed" : "pointer",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: 14, color: disabled ? "#ccc" : "#534AB7",
      }}
    >
      {label}
    </button>
  );
}

function TripCard({ trip, onClick }) {
  return (
    <div onClick={onClick} style={{cursor: "pointer",
      background: "#fff", border: "0.5px solid #e0d8f5",
      borderRadius: 10, padding: 14, marginBottom: 12,
    }}>
      {/* Card Header */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
        <span style={{ fontSize: 12, color: "#555" }}>S No. : <strong>{trip.sno}</strong></span>
        <span style={{ fontSize: 12, color: "#e05c8a", fontWeight: 500 }}>Date : {trip.date}</span>
      </div>

      {/* KM Display */}
      <div style={{
        background: "#f0eeff", borderRadius: 8, padding: "10px 12px",
        display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10,
      }}>
        <div style={{
          width: 36, height: 36, borderRadius: "50%", background: "#fff",
          border: "2px solid #534AB7", display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="#534AB7" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
        </div>
        <span style={{ fontSize: 18, fontWeight: 500, color: "#534AB7" }}>
          {trip.km} <span style={{ fontSize: 13, color: "#888", fontWeight: 400 }}>km</span>
        </span>
      </div>

      {/* Details */}
      {[
        { label: "Lead ID",              value: trip.leadId },
        { label: "Km Count (Starting)", value: trip.start },
        { label: "Km Count (Ending)",   value: trip.end },
      ].map(({ label, value }) => (
        <div key={label} style={{ display: "flex", gap: 6, fontSize: 12, marginBottom: 4 }}>
          <span style={{ color: "#888", width: 160, flexShrink: 0 }}>{label}</span>
          <span style={{ color: "#333", fontWeight: 500 }}>: {value}</span>
        </div>
      ))}
    </div>
  );
}